import React, { useEffect, useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { AppSettings } from './../../config/app-settings.js'
import { useDispatch } from 'react-redux'
import { login as loginAction } from '../../redux/slices/authSlice.js'
import Loader from '../pages/loader.js'
import * as Yup from 'yup'
import { useLoginMutation } from '../../redux/Api/UserManagment/uMUserApiSlice.js'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'

const validationSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  password: Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required')
})

function PagesLogin () {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loginUser, { isLoading, isError, error }] = useLoginMutation()

  const context = useContext(AppSettings)

  useEffect(() => {
    context.setAppHeaderNone(true)
    context.setAppSidebarNone(true)
    context.setAppContentClass('p-0')

    return () => {
      context.setAppHeaderNone(false)
      context.setAppSidebarNone(false)
      context.setAppContentClass('')
    }
  }, [context])

  const validation = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema,
    onSubmit: async values => {
      try {
        const response = await loginUser(values).unwrap()
        toast.success('User logged In successfully')

        if (response?.access_token) {
          dispatch(
            loginAction({
              access_token: response?.access_token,
              refresh_token: response?.refresh_token,
              authUser: response?.authUser
            })
          ) // Save token to Redux
          localStorage.setItem('access_token', response?.access_token)
          localStorage.setItem('refresh_token', response?.refresh_token)
          localStorage.setItem('authUser', JSON.stringify(response?.authUser))
          navigate('/')
        }
      } catch (err) {
        toast.error(err?.data?.error)
      }
    }
  })

  return (
    <div className='login'>
      <Loader isLoading={isLoading} />
      <div className='login-content'>
        <form onSubmit={validation.handleSubmit}>
          <h1 className='text-center'>Sign In</h1>
          <div className='text-inverse text-opacity-50 text-center mb-4'>
            For your protection, please verify your identity.
          </div>
          <div className='mb-3'>
            <label className='form-label'>
              Email Address <span className='text-danger'>*</span>
            </label>
           <input
              id='email'
              name='email'
              type='email'
              value={validation.values.email}
              onChange={validation.handleChange}
              className='form-control form-control-lg bg-white bg-opacity-5'
              onBlur={validation.handleBlur}
              placeholder='Enter your email'
            />
          </div>
          <div className='mb-3'>
            <div className='d-flex'>
              <label className='form-label'>
                Password <span className='text-danger'>*</span>
              </label>
              <Link
                to='#/'
                className='ms-auto text-inverse text-decoration-none text-opacity-50'
              >
                Forgot password?
              </Link>
            </div>
             <input
              id="password"
              name="password"
              type="password"
              value={validation.values.password}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              placeholder="Enter your password"
              className='form-control form-control-lg bg-white bg-opacity-5'
              
            />
          </div>
          <div className='mb-3'>
            <div className='form-check'>
              <input
                className='form-check-input'
                type='checkbox'
                id='customCheck1'
              />
              <label className='form-check-label' htmlFor='customCheck1'>
                Remember me
              </label>
            </div>
          </div>
          <button
            type='submit'
            className='btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3'
          >
            {isLoading ? 'Loading...' : 'Sign In'}
          </button>
          {isError && (
            <div className='mt-2 text-center text-sm text-red-500'>
              {error?.data?.error || 'Something went wrong, please try again.'}
            </div>
          )}
        </form>
      </div>
    </div>
  )
}

export default PagesLogin
